import React, {useMemo} from 'react';
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import PointsGroupClusterSingleVoyage
    from "@containers/singleVoyage/containers/points/cluster/pointsGroupCluster/PointsGroupClusterSingleVoyage";
import PointOnTheMapMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/map/pointOnTheMap/PointOnTheMapMutateSingleVoyage";
import {
    usePointActionMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/points/hooks/usePointActionMutateSingleVoyage";

const PointsOnTheMapMutateSingleVoyage = () => {

    const {
        points,
    } = useRootContextMutateSingleVoyage()

    const {
        onChangePosition,
        onChangeTargetPoint,
        isLoading,
    } = usePointActionMutateSingleVoyage()



    const list = useMemo(() => {
        return points?.map((point, index) => {
            return (
                <PointOnTheMapMutateSingleVoyage
                    key={point.id}
                    point={point}
                    index={index}
                    onChangePosition={onChangePosition}
                    onClickPoint={onChangeTargetPoint}
                    disabled={isLoading}
                />
            )
        })
    }, [points, onChangePosition, onChangeTargetPoint])

    if (!points?.length) {
        return <></>
    }

    return (
        <>
            <PointsGroupClusterSingleVoyage
                hasRerenderOnChangeChildren
            >
                {list}

            </PointsGroupClusterSingleVoyage>
        </>
    );
};

export default PointsOnTheMapMutateSingleVoyage;
